import { render } from "./QRCodeReaderControl.vue?vue&type=template&id=a0a1a28a"
import script from "./QRCodeReaderControl.vue?vue&type=script&lang=js"
export * from "./QRCodeReaderControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__